/**
 * @generated SignedSource<<29dfc50c10fbe22eba2a58f9a4424cb4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type Platform_FollowUrlRedirectsQuery$variables = {
  url: string;
};
export type Platform_FollowUrlRedirectsQuery$data = {
  readonly followUrlRedirects: string | null;
};
export type Platform_FollowUrlRedirectsQuery = {
  response: Platform_FollowUrlRedirectsQuery$data;
  variables: Platform_FollowUrlRedirectsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "url"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "url",
        "variableName": "url"
      }
    ],
    "kind": "ScalarField",
    "name": "followUrlRedirects",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "Platform_FollowUrlRedirectsQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "Platform_FollowUrlRedirectsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e52d26dfe7436f575ae8dcaf07e247fd",
    "id": null,
    "metadata": {},
    "name": "Platform_FollowUrlRedirectsQuery",
    "operationKind": "query",
    "text": "query Platform_FollowUrlRedirectsQuery(\n  $url: String!\n) {\n  followUrlRedirects(url: $url)\n}\n"
  }
};
})();

(node as any).hash = "3b247ab01b673014ace94ea5ee8fcade";

export default node;
